import { Breaks } from './types';

export const breaksSlugs = [Breaks.Sickness, Breaks.Vacation, Breaks.Unpaid];
